export default __webpack_public_path__ + "static/media/logo_full.18aa3b6e.svg";